import React, { useEffect, useState } from "react";
import BoardTable from "../../components/common/board/BoardTable";
import BoardPagination from "../../components/common/board/BoardPagination";
import SearchBar from "../../components/common/board/SearchFilterBar";
import { getPhotoBoardList, createPhotoBoard } from "../../api/const";
import { useParams, useNavigate } from "react-router-dom";
import BoardToolbar from "../../components/common/board/BoardToolbar";
import PageHeader from "../../components/common/ui/PageHeader";

export default function PhotoBoard() {
  const { id: projectId } = useParams();
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [total, setTotal] = useState(0);

  // 검색 필터
  const [q, setQ] = useState("");
  const [searchField, setSearchField] = useState("title");
  const [dateFilter, setDateFilter] = useState("all"); // 추가
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [searchTrigger, setSearchTrigger] = useState(0);

  const columns = [
    {
      key: "title",
      header: "제목",
      headerAlign: "center", // 헤더 가운데 정렬
      align: "center", // 데이터 셀 가운데 정렬
      render: (row) => (
        <div className="truncate max-w-[300px]">{row.title}</div>
      ),
    },
    { key: "created_by", header: "작성자", width: 120 },
    {
      key: "date",
      header: "작성일",
      width: 160,
      render: (row) =>
        row.date ? new Date(row.date).toLocaleDateString("ko-KR") : "-",
    },
  ];

  const fetchData = async () => {
    if (!projectId) return;

    setLoading(true);
    setError("");

    try {
      const params = {
        project: projectId,
        [searchField]: q,
        start_date: startDate,
        end_date: endDate,
        page,
        page_size: pageSize,
      };

      const res = await getPhotoBoardList(projectId, params);

      setRows(res.results ?? res);
      setTotal(res.count ?? res.total ?? res.length);
    } catch (e) {
      console.error(e);
      setError("사진대지 데이터를 불러오지 못했습니다.");
    } finally {
      setLoading(false);
    }
  };

  // 페이지 또는 필터 변경 시 fetch
  useEffect(() => {
    fetchData();
  }, [projectId, page, pageSize, searchTrigger]);

  const handleSearch = () => {
    setPage(1);
    setSearchTrigger((v) => v + 1);
  };

  const handleCreate = async () => {
    try {
      const newBoard = await createPhotoBoard({
        project: projectId,
        title: "새 사진대지",
        photo_ids: [],
      });
      navigate(`view/${newBoard.id}`);
    } catch {
      alert("생성 실패");
    }
  };

  return (
    <div className="max-w-8xl mx-auto p-6 rounded-2xl bg-gray-50">
      {/* 헤더 */}
      <PageHeader>사진대지 목록</PageHeader>

      {/* SearchBar 오른쪽 정렬 */}
      <BoardToolbar
        right={
          <>
            <SearchBar
              q={q}
              onChangeQ={setQ}
              searchField={searchField}
              onChangeSearchField={setSearchField}
              dateFilter={dateFilter}
              onChangeDateFilter={setDateFilter}
              startDate={startDate}
              endDate={endDate}
              onDateChange={({ start, end }) => {
                setStartDate(start);
                setEndDate(end);
              }}
              onSearch={handleSearch}
              pageSize={pageSize}
              onChangePageSize={setPageSize}
              searchFieldOptions={[
                { value: "author", label: "작성자" },
                { value: "title", label: "제목" },
              ]}
            />
            <button className="btn-save" onClick={handleCreate}>
              새 사진대지 등록
            </button>
          </>
        }
      />

      {/* 리스트 */}
      <BoardTable
        columns={columns}
        rows={rows}
        loading={loading}
        error={error}
        emptyText="사진대지가 없습니다."
        onRowClick={(row) => navigate(`view/${row.id}`)}
      />

      {/* 페이지네이션 */}
      <div className="mt-4">
        <BoardPagination
          page={page}
          pageSize={pageSize}
          total={total}
          onPageChange={setPage}
        />
      </div>
    </div>
  );
}
